module.exports = __webpack_public_path__ + "img/knu2_gallery0.d4e9ef60.jpg";